/*
 * @Author: zhaoyang
 * @Date: 2024-02-24 14:38:23
 * @Last Modified by: zhaoyang
 * @Last Modified time: 2024-02-24 17:50:27
 */

import {Form, Input, Checkbox, Radio, DatePicker, Upload} from 'ant-design-vue';

export default {
    install(Vue) {
        Vue.use(Form);
        Vue.use(Input);
        Vue.use(Checkbox);
        Vue.use(DatePicker);
        Vue.use(Upload);
        Vue.use(Radio);
    }
};
